import React from "react";
import { Link } from "react-router-dom";

const AccesoDirectoDocument = ({ href, label, icon, totalDocs }) => {
    return (
        <Link to={href} className="
            w-full h-44 flex flex-col items-center justify-center
            transition transform hover:scale-105
            bg-rs-azul rounded-lg hover:bg-rs-rojo p-2 text-center shadow-md shadow-black hover:shadow-xl hover:shadow-rs-rojo">
            {React.createElement(icon, { size: 30, color: "white" })}
            <h2 className="text-white text-xl font-bold">{label}</h2>
            <p className="text-white">{totalDocs} registros</p>
        </Link>
    );
};

export default AccesoDirectoDocument;